import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/media/media-coverage/components/MediaCoverageView.tsx");
